var map = {
	"./stripeWidth1.svg": 70877,
	"./stripeWidth2.svg": 42430,
	"./stripeWidth3.svg": 21359,
	"./stripeWidth4.svg": 3888,
	"./stripeWidth5.svg": 2337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21749;